import type { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  eyebrow?: string
  description?: string
  // Статус/бейдж — над заголовком (свойство сущности), отдельно от кнопок-действий.
  status?: ReactNode
  actions?: ReactNode
}

export function PageHeader({ title, eyebrow, description, status, actions }: PageHeaderProps) {
  return (
    <header className="mb-6 flex flex-col">
      {eyebrow && <span className="label mb-1">{eyebrow}</span>}
      {status && <div className="mb-2">{status}</div>}
      {/* flex-wrap: на узких экранах экшены уезжают под заголовок, а не за край. */}
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-3">
        <h1 className="t-h2 min-w-0 flex-1 basis-56 truncate text-text-primary">{title}</h1>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
      {description && <p className="mt-4 text-text-secondary">{description}</p>}
    </header>
  )
}
